export const FORM_OVERFLOW_CUSTOM_STYLE = {
    display: 'grid',
    gridTemplateRows: 'auto 1fr auto',
};

export const FORM_OVERFLOW_LARGE_MODAL_STYLE = {
    display: 'grid',
    gridTemplateRows: 'auto 1fr auto',
    width: '90vw',
    maxWidth: '1200px',
    height: '90dvh',
    maxHeight: '800px',
};
